import { useTranslation } from 'react-i18next';
import { skipToken } from '@reduxjs/toolkit/query';
import { EmployeeStatusEnum } from '@electricjs/core_entity-client';

import {
  ColorsV2,
  Icon,
  spaces,
  Tooltip,
  useThemeColors,
} from '@electricjs/arc';

import { useGetEmployeeFromDirectoryQuery } from '@/redux/slices/employeeApiSlice';
import { useGetLatestOffboardingByEmployeeIdQuery } from '@/redux/slices/offboardingApiSlice';
import formatDate from '@/helpers/formatDate';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
type EmployeeOffboardedWarningIconProps = {
  employeeId?: string;
};

const EmployeeOffboardedWarningIcon = ({
  employeeId,
}: EmployeeOffboardedWarningIconProps) => {
  const { t } = useTranslation('people');
  const organizationId = useGetOrganizationId();
  const [warningTextColor] = useThemeColors([ColorsV2.WARNING]);
  const { data: fullEmployee } = useGetEmployeeFromDirectoryQuery(
    employeeId
      ? {
          employeeId,
          organizationId: organizationId,
        }
      : skipToken
  );
  const { data: offboardingData } = useGetLatestOffboardingByEmployeeIdQuery(
    employeeId && fullEmployee?.status === EmployeeStatusEnum.Inactive
      ? {
          organizationId,
          employeeId,
        }
      : skipToken
  );

  if (!fullEmployee || fullEmployee.status !== EmployeeStatusEnum.Inactive) {
    return null;
  }

  const offboardingDate =
    offboardingData?.scheduledAt ?? offboardingData?.createdAt;

  return (
    <Tooltip
      content={
        offboardingData
          ? offboardingDate
            ? t('employeeOffboardedWarningIcon.employeeWasOffboardedOn', {
                date: formatDate(offboardingDate),
              })
            : t('employeeOffboardedWarningIcon.employeeWasOffboarded')
          : t('employeeOffboardedWarningIcon.employeeIsInactive')
      }
      placement="top">
      <Icon
        icon="alert-triangle"
        size="small"
        mr={spaces.space_xs}
        color={warningTextColor}
      />
    </Tooltip>
  );
};

export default EmployeeOffboardedWarningIcon;
